import { render, staticRenderFns } from "./viewManagement.vue?vue&type=template&id=0b1c8fca&scoped=true"
import script from "./viewManagement.vue?vue&type=script&lang=js"
export * from "./viewManagement.vue?vue&type=script&lang=js"
import style0 from "./viewManagement.vue?vue&type=style&index=0&id=0b1c8fca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c8fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1c8fca')) {
      api.createRecord('0b1c8fca', component.options)
    } else {
      api.reload('0b1c8fca', component.options)
    }
    module.hot.accept("./viewManagement.vue?vue&type=template&id=0b1c8fca&scoped=true", function () {
      api.rerender('0b1c8fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/develop/viewManagement.vue"
export default component.exports